module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"States":"État / Province"},"fr":{"States":"État / Province"}}')
  delete Component.options._Ctor
}
